import { render, staticRenderFns } from "./LocalMonitor.vue?vue&type=template&id=ec0a159e&"
import script from "./LocalMonitor.vue?vue&type=script&lang=js&"
export * from "./LocalMonitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports